export default "__VITE_ASSET__8563f2fb__"